import { render, staticRenderFns } from "./ReviewPatientInviteTabs.vue?vue&type=template&id=e63f7f56&scoped=true"
import script from "./ReviewPatientInviteTabs.vue?vue&type=script&lang=js"
export * from "./ReviewPatientInviteTabs.vue?vue&type=script&lang=js"
import style0 from "./ReviewPatientInviteTabs.vue?vue&type=style&index=0&id=e63f7f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63f7f56",
  null
  
)

export default component.exports